var search4i = function(){
	var searchAutoComplete,
	watermarkText = 'Search',
	panel = document.getElementById("SuggestionPanel"),
	searchTxtBox = document.getElementById("txtSearch"),
	searchStatus = document.getElementById("searchStatus"),
	searchButton = document.getElementById("submitSearch"),
	keys = {
		ESC: 27,
		TAB: 9,
		RETURN: 13,
		UP: 38,
		DOWN: 40,
		RIGHT: 39,
		LEFT: 37,
		BACK: 8,
		SPACE: 32
	},
	autoCompleteOptions = {
		selector: searchTxtBox, 
		appendTo: document.getElementById("autoCompWrapper"), // custom
		minChars: 2,
		source: function(searched, suggest){
			searched = searched.toLowerCase();
			try { autoCompleteRequest.abort(); } catch(e){}
			fetch('/Header/SearchAutoComplete', { method: 'POST', body: JSON.stringify({ searchTerm: searched }), headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				// response includes array of objects with SearchTerm and ResultCount values
                		if (response.length === 0 || searchTxtBox.value === "" || searchTxtBox.value === watermarkText){
					searchStatus.innerHTML = 'No autocomplete results available';
				} else{ 
					searchStatus.innerHTML = response.length + ' Autocomplete results are available for '+ searchTxtBox.value + ', use up and down arrow keys to navigate.'; 
				}
				suggest(response);
			});
		},
		onSelect: function(e, term, item){
			e.preventDefault();
			term.value = item;
            		search(item);
		},
		renderItem: function (item, search){
			search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // term searched for in input field
			var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
			return '<li class="autocomplete-suggestion pointer" role="option" aria-selected="false" aria-haspopup="true" data-val="' + item.SearchTerm + '"><span class="searchAutoLeft floatLeft">' + item.SearchTerm.replace(re, '<span class="bold">$1</span>') + '</span><span class="floatRight">' + item.ResultCount + ' results</span></li>';
		},
		termSelected: function(e, term, item){ // custom
			showSuggestionPanel(term);
		},
		onClose: function(){ // custom
			//hideSuggestionPanel();
		}
	},
	initAutoComplete = function(){
		searchAutoComplete = new autoComplete(autoCompleteOptions);
	},
	destroyAutoComplete = function(){
		searchAutoComplete.destroy();
	},
	showSuggestionPanel = function(searchTerm){
		fetch('/Header/SearchBoxSuggestions', { method: 'POST', body: JSON.stringify({ searchTerm: searchTerm }), headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }}).then(function(response){
				return  (response.ok) ? response.text() : ''; // response.text() returns a promise
			}).then(function(response){
				// set left position to be to the right of autocomplete list
				var leftPosition = document.getElementById("txtSearch").offsetWidth + 7;
				panel.style.left = leftPosition + "px";
				panel.innerHTML = response;
				panel.classList.remove("hide");
				panel.style.display = "block";
				panel.setAttribute("aria-hidden", "false");
				panel.addEventListener("keydown", function(e){
					if(e.keyCode == keys.ESC){
						hideSuggestionPanel();
						searchTxtBox.focus();
					}
					if(document.getElementById("SearchSuggestionPanelViewAll") == document.activeElement){
						switch (e.keyCode) {
							case keys.TAB:
								panel.getElementsByTagName("a")[0].focus();
						}
					}
					if(panel.getElementsByTagName("a")[0] == document.activeElement){
						switch (e.keyCode) {
							case keys.LEFT:
								hideSuggestionPanel();
								searchTxtBox.focus();
						}
					}
				});
				
				if(document.getElementById("closeSearchSuggestion")){
					document.getElementById("closeSearchSuggestion").addEventListener("click", function(e){
						e.preventDefault();
						hideSuggestionPanel();
						searchTxtBox.focus();
					});
				}
			});
		
		searchTxtBox.addEventListener("keyup", function(e){
			if(e.keyCode == keys.RIGHT){
				panel.getElementsByTagName("a")[0].focus();
			}
		});
	},	
	hideSuggestionPanel = function(e){
		panel.classList.add("hide");
		panel.setAttribute("aria-hidden", "true");
		panel.style.display = "none";
	},
	search = function(el) {
		var searchText;
		if (el.id == "submitSearch") {
			searchText = searchTxtBox.value;
		}else {
			searchText = el.getAttribute("data-val");
		}
		//don't search for nothing
		if(searchText !== watermarkText){
			fetch('/Header/Search', { method: 'POST', body: JSON.stringify({ searchText: searchText }), headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }}).then(function(response){
				return  (response.ok) ? response.json() : {url: ''}; // response.text() returns a promise
			}).then(function(response){
				if(response.url !== '') window.location.href = response.url;
			});
		}
	},	
	addSearchEvents = function(){
		searchButton.addEventListener("click", function(e){
			e.preventDefault();
			search(searchButton);
		}); 
		searchTxtBox.addEventListener('focus', function(e){
			initAutoComplete(); // don't initialize on page load due to accessibility issues
		});
		searchTxtBox.addEventListener('blur', function(e){
			destroyAutoComplete();
		});	
		searchTxtBox.addEventListener('keyup', function(e){
			if(e.keyCode == keys.RETURN) {
				search(searchButton);
			}
		});
		document.addEventListener("keydown", function(e){
			if((document.getElementById("SuggestionPanel").getAttribute("aria-hidden") == "false") && (e.keyCode == keys.ESC)){
				hideSuggestionPanel();
				searchTxtBox.focus();
			}			
		});
		/*document.addEventListener('click', function(e){
			if(panel.style.display === "block"){
				if(e.target.closest('#SuggestionPanel') || e.target.closest("#autoCompWrapper")){
					hideSuggestionPanel();
				}
			}
		}, false);*/
	},	
	init = function(){
		addSearchEvents();
		initAutoComplete();
	};
	
	return{
		Init: init
	};
};
(function(){
	var loadSearch = new search4i();
	loadSearch.Init();
})();